import toggleNav from './components/toggleNav';
import smoothScroll from './components/smooth-scroll';
import lazyLoadImages from './components/lazy-load-images';
import packagesSticky from './components/packages-sticky';
import mobileSlider from './utils/mobile-slider';
import loadCart from "../../src/js/components/loadCart";
import addToCart from "../../src/js/components/addToCart";
import removeCart from "../../src/js/components/removeCart";

$(function () {
  toggleNav();
  smoothScroll();
  lazyLoadImages();
  packagesSticky();
  mobileSlider('.js-slider-sp');
  loadCart();
  addToCart();
  removeCart();
});

$(window).on('scroll', function () {
  lazyLoadImages();
  packagesSticky();
});
